<template>
  <div class="d-flex flex-column justify-content-center align-items-center col-md-11 router-view-background">
    <float-button 
      icon="mdi mdi-plus"
      v-tooltip.top="tooltipButton"
      @event="openSidebar"
      :class="canCreate ? '' : 'disable-button'"
    />
    <div class="col-md-12">
      <the-filters
        :filters="computedFilters"
        :showCleareble="showRedefine"
        @get-model="getFiltersModel"
        @on-cleareble="getAnimals"
        @search="searchItems"
      />
    </div>
    <div class="col-md-12">
      <the-table 
        :key="tableKey"
        :dataItems="computedAnimals"
        :headers="headersForTable"
      >
        <template v-slot:actions="{item}">
          <b-dropdown right id="dropdown-menu-table" text="Menu" variant="menu-table" class="m-2 p-0 menu-table">           
            <b-dropdown-item
              class="pr-5 pl-5 b-drop-options"
              :class="canCreate ? '' : 'disable-button'"
              variant="text"
              @click="editAnimal(item)"
              v-tooltip.top="tooltipButton"
            >
              <i class="mdi mdi-pencil pr-5"></i> Editar Animal
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </the-table>
    </div>
    <div 
      v-if="computedAnimals.length"
      class="col-md-12 d-flex justify-content-end" 
      style="margin-top:2vh"
    >
      <v-pagination
        v-model="page"
        :length="total_pages"
        :total-visible="8"
        color="var(--jersey-yellow)"
      ></v-pagination>
    </div>
    <sidebar-edit 
      :animal="animalEdit"
      :blood_degrees="degree_blood"
      :races="races"
      @close="(SET_ACTIVE(false), animalEdit = {})"
      @save="save"
    />
  </div>
</template>

<script>
import TheFilters from "@/components/layout/TheFilters";
import TheTable from "@/components/layout/TheTable";
import FloatButton from "@/components/layout/ButtonFloat";
import {mapState, mapActions, mapMutations} from "vuex";
import {BDropdown, BDropdownItem} from "bootstrap-vue";
import mixins from "@/mixins/helpers.js";
export default {
  name:"AnimalsList",
  mixins:[mixins],
  components: {
    TheFilters,
    TheTable,
    BDropdown,
    BDropdownItem,
    FloatButton,
    SidebarEdit: () => import("./SidebarEdit.vue")
  },
  data() {
    return {
      showRedefine:false,
      headersForTable:[
        {text:"Nome", value:"name", sortable:true},
        {text:"Botton", value:"code", sortable:true},
        {text:"Registro", value:"register", sortable:true},
        {text:"Raça", value:"race", sortable:true},
        {text:"Composição Racial", value:"degree_blood", sortable:true},
        {text:"Status", value:"status", sortable:true},
        {text:"", value:"actions", has_slot:true},
      ],
      query:{},
      allAnimals:[],
      tableKey:0,
      valuePerPage:10,
      animalEdit:{},
      tooltipButton:"Para Cadastrar animais selecione o Criador nos filtros",
      canCreate: false
    }
  },
  computed: {
    ...mapState("creators", ["creators"]),
    ...mapState("farms", ["farms"]),
    ...mapState("animals", ["degree_blood", "races"]),
    ...mapState("login", ["user"]),
    //Essa computed devolve os filtros do componente
    computedFilters() {
      return [
        {name:"creator", type:"select", label:"Criador", items:this.creators},
        {name:"farm", type:"select", label:"Fazenda", items:this.farms},
        {name:"name", type:"text", label:"Nome"},
        {name:"register", type:"text", label:"Registro"},
        {name:"botton", type:"text", label:"Botton"},
      ]
    },
    computedAnimals() {
      return this.allAnimals.map(e => ({...e, status:e.status ? e.status : ""}));
    },
  },
  methods: {
    ...mapActions("creators", [
      "actionGetCreators"
    ]),
    ...mapActions("farms", [
      "actionGetFarms"
    ]),
    ...mapActions("animals", [
      "actionGetAllAnimals",
      "actionSaveNewAnimal",
      "actionEditAnimal"
    ]),
    ...mapMutations("sidebar", [
      "SET_ACTIVE"
    ]),
    openSidebar() {
      if(this.canCreate) {
        this.SET_ACTIVE(true);
      } else {
        return;
      }
    },
    checkIfCanManipulateAnimals() {
      if(this.user.roles.find(e => e.name === "animals.create")) {
        if(this.query.farm) {
          this.canCreate = true;
          this.tooltipButton = "";
        } else {
          this.tooltipButton = "Para cadastrar ou editar animais selecione a fazenda no filtro";
          this.canCreate = false;
        }
      } else {
        this.tooltipButton = "Para cadastrar ou editar animais você deve possuir a permissão";
        this.canCreate = false;
      }
    },
    //Esse metodo é especifico para resetar os item iniciais de serviço
    async getFiltersModel(data) {
      this.query[data.title] = data.value;
      if(data.title === "creator") {
        await this.actionGetFarms(data.value);
        this.allAnimals = [];
        this.query.farm = null; // a fazenda do criador anterior não vale mais
        localStorage.removeItem("list-animals");
      }
      if(data.title === "farm") {
        await this.loadFarmAnimals(data.value);
      }
      this.checkIfCanManipulateAnimals();
    },
    // lista por fazenda (sistema do Rapha): a lista inteira fica no localStorage p/ paginação e busca
    async loadFarmAnimals(farm) {
      const animals = (await this.actionGetAllAnimals(farm)).map(e => ({...e, status:e.status ? e.status.title : ""}));
      localStorage.setItem("list-animals", JSON.stringify(animals));
      this.total_pages = Math.ceil(animals.length / this.valuePerPage);
      this.total_items = animals.length;
      this.allAnimals = animals.filter((a,i) => i < this.valuePerPage);
    },
    async getAnimals() {
      await this.loadFarmAnimals(this.query.farm);
      delete this.query.name;
      delete this.query.botton;
      delete this.query.register;
      this.showRedefine = false;
    },
    //Essa função faz o get dos items da tabela conforme os filtros
    // I3: busca parcial, sem diferenciar maiúsculas, na lista INTEIRA da fazenda (não só na página)
    searchItems() {
      const {name, register, botton} = this.query;
      const has = (value, q) => String(value || "").toLowerCase().includes(String(q).toLowerCase());
      const match = name ? e => has(e.name, name) : register ? e => has(e.register, register) : botton ? e => has(e.code, botton) : null;
      if(!match) return this.$toast.warning("Informe ao menos um filtro de pesquisa !");
      let full = [];
      try { full = JSON.parse(localStorage.getItem("list-animals")) || []; } catch(e) { full = []; }
      this.allAnimals = full.filter(match);
      this.total_pages = 1;
      this.showRedefine = true;
    },
    editAnimal(animal) {
      if(this.canCreate) {
        this.animalEdit = animal;
        this.SET_ACTIVE(true);
      } else {
        return 
      }
    },
    async save(animal) {
      if(animal.id) {
        const payloadEdit = {
          name: animal.name,
          born_at: animal.born_at,
          code: animal.code,
          gender: animal.gender,
          degree_blood: animal.degree_blood,
          active: animal.active,
          register: animal.register,
          rgn: animal.rgn,
          code_integration: animal.code_integration,
          id: animal.id,
          race: animal.race,
          surname: animal.surname
        }
        await this.actionEditAnimal({animal: {...payloadEdit, farm_id: this.query.farm}});
      } else {
        await this.actionSaveNewAnimal({animal: {...animal, farm_id: this.query.farm}});
      }
      this.SET_ACTIVE(false);
      this.page = 1;
      await this.loadFarmAnimals(this.query.farm);
      this.animalEdit = {};
    }
  },
  async mounted() {
    await this.actionGetCreators();
  }
}
</script>

<style scoped>
 .disable-button {
    opacity: 0.5;
  }
</style>
